<template>
    <div class="row">
        <Main class="col-md-8 pr-0"></Main>
        <Side class="col-md-4 pr-0"></Side>
    </div>
</template>

<script>
        import Main from '@/components/main_page/sub_components/learning_main.vue'
        import Side from '@/components/main_page/sub_components/learning_side.vue'

    export default {
        name: "learning",
        components: {
            Main,
            Side,
        },
    }
</script>

<style scoped>

</style>